import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcEyeOff40Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { useBlurChatPresenter } from './BlurChat.presenter';
import styles from './BlurChat.styles.m.css';

export const BlurChat: FC<{ groupId: string }> = observer(({ groupId }) => {
  const { t } = useTranslation();
  const presenter = useBlurChatPresenter(groupId);

  if (presenter.isShowContent) {
    return null;
  }

  return (
    <div className={styles.container}>
      <IcEyeOff40Icon className={styles.icon} />
      <div className={styles.label}>{t('chat_unknown_sender_warning')}</div>
      <Button
        theme="secondary-white"
        onClick={presenter.onShow}
      >
        {t('common_show')}
      </Button>
    </div>
  );
});
